import {motion} from 'framer-motion';
import {useState} from 'react';

const Toggle = ({children,title,duration}) => {
    const [toggle,setToggle] = useState(false);

    return (
        <motion.div layout className = 'question' onClick = {() => {setToggle(!toggle)}}>
            <motion.h4 layout> {title} </motion.h4>
            <br></br>
            <motion.h3 layout> {duration} </motion.h3>
            {toggle? children:""}
            <div className="faq-line"></div>

        </motion.div>
    )

};

export default Toggle;